const baseUrl = 'http://122.169.32.36/v1'
// const baseUrl = 'http://localhost:4002/v1'

export default baseUrl
